"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_datetime_1 = require("owa-datetime");
var createRecipientWell_1 = require("owa-readwrite-recipient-well/lib/utils/createRecipientWell");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getClauseTypeProperties(clauseType) {
    switch (clauseType) {
        case 'moveTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_moveTo,
                headerType: 'organize',
                initialValue: null,
            };
        case 'copyTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_copyTo,
                headerType: 'organize',
                initialValue: null,
            };
        case 'delete':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_delete,
                headerType: 'organize',
                initialValue: null,
            };
        case 'pin':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_pinToTop,
                headerType: 'organize',
                initialValue: null,
            };
        case 'read':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_read,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'junk':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_junk,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'markImportance':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_importance,
                headerType: 'markMessage',
                initialValue: null,
            };
        case 'forwardTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_forwardTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'forwardAsAttachmentTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_forwardAsAttachmentTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'redirectTo':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_redirectTo,
                headerType: 'route',
                initialValue: createRecipientWell_1.default(),
            };
        case 'from':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_from,
                headerType: 'addresses',
                initialValue: createRecipientWell_1.default(),
            };
        case 'to':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_to,
                headerType: 'addresses',
                initialValue: createRecipientWell_1.default(),
            };
        case 'onTheToOrCcLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_toOrCcLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'theOnlyRecipientListed':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_onlyRecipient,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'onTheToLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_toLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'onTheCcLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_ccLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'notOnTheToLine':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_notToLine,
                headerType: 'myNameIs',
                initialValue: null,
            };
        case 'subjectIncludes':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_subjectIncludes,
                headerType: 'subject',
                initialValue: [],
            };
        case 'subjectOrBodyIncludes':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_subjectOrBodyIncludes,
                headerType: 'subject',
                initialValue: [],
            };
        case 'inTheBody':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inBody,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheSenderAddress':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inSenderAddress,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheRecipientAddress':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inRecipientAddress,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'inTheMessageHeader':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_inMessageHeader,
                headerType: 'includesTheseWords',
                initialValue: [],
            };
        case 'withImportance':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_importance,
                headerType: 'markedWith',
                initialValue: null,
            };
        case 'sensitivity':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_sensitivity,
                headerType: 'markedWith',
                initialValue: null,
            };
        case 'flag':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_flag,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'type':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_type,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'attachment':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_attachment,
                headerType: 'messageIncludes',
                initialValue: null,
            };
        case 'atLeast':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_atLeast,
                headerType: 'messageSize',
                initialValue: 0,
            };
        case 'atMost':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_atMost,
                headerType: 'messageSize',
                initialValue: 0,
            };
        case 'before':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_before,
                headerType: 'received',
                initialValue: new Date(owa_datetime_1.now()),
            };
        case 'after':
            return {
                clauseType: clauseType,
                dropdownOptionText: owa_options_strings_1.default.options_inboxRules_after,
                headerType: 'received',
                initialValue: new Date(owa_datetime_1.now()),
            };
        default:
            throw new Error('Cannot get clause type properties for a clause type that does not exist');
    }
}
exports.default = getClauseTypeProperties;
//# sourceMappingURL=getClauseTypeProperties.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getClauseTypeProperties.js
// module id = 5196
// module chunks = 2